const INITIAL_STATE = {
  empresa: {},
  empresaPessoa: {},
  empresaJuridico: {},
  empreEndereco: {},
  empreEnderecoCobranca: {},
  empreContato: {},
  empreTelefones: {
    data: []
  },
  empreContasBancarias: [],
  empreBanco: {},
  empreTelefone: {}
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'EMPRESA_FETCHED':
      return {
        ...state,
        empresaPessoa: action.payload.filial.pessoa,
        empreContato: action.payload.filial.pessoa.contato,
        empresaJuridico: action.payload.filial.pessoa.juridica,
        empreBanco: action.payload.filial.pessoa.banco,
        empreTelefones: action.payload.filial.pessoa.telefones,
        empreEndereco: action.payload.filial.pessoa.endereco,
        empreEnderecoCobranca: action.payload.enderecoCobranca
      }
    case 'EMPRESAPESSOAL_SET':
      const pessoa = { ...state.empresaPessoa }
      pessoa[action.payload.propriedade] = action.payload.value
      return { ...state, empresaPessoa: pessoa }
    case 'EMPRESAJURIDICO_SET':
      const juridico = { ...state.empresaJuridico }
      juridico[action.payload.propriedade] = action.payload.value
      return { ...state, empresaJuridico: juridico }
    case 'EMPRESAENDERECO_SET':
      const endereco = { ...state.empreEndereco }
      endereco[action.payload.propriedade] = action.payload.value
      return { ...state, empreEndereco: endereco }
    case 'EMPRESAENDERECOCOBRANCA_SET':
      const enderecoCobranca = { ...state.empreEnderecoCobranca }
      enderecoCobranca[action.payload.propriedade] = action.payload.value
      return { ...state, empreEnderecoCobranca: enderecoCobranca }
    case 'EMPRESACONTATO_SET':
      const banco = { ...state.empreContato }
      banco[action.payload.propriedade] = action.payload.value
      return { ...state, empreContato: banco }
    case 'EMPRESBANCO_SET':
      const contato = { ...state.empreContato }
      contato[action.payload.propriedade] = action.payload.value
      return { ...state, empreContato: contato }
    case 'EMPRESA_TELEFONES_ADD': {
      return { ...state, empreTelefones: action.payload }
    }
    case 'ENDERECO_COBRANCA_ADD': {
      const empreEnderecoCobrancaCopy = [...state.empreEnderecoCobranca]
      return { ...state, empreEnderecoCobranca: empreEnderecoCobrancaCopy }
    }
    case 'EMPRESA_TELEFONES_DELETE': {
      const empreTelefonesCopy = [...state.empreTelefones]
      empreTelefonesCopy.splice(action.index, 1)
      return { ...state, empreTelefones: empreTelefonesCopy }
    }
    case 'EMPRESA_TELEFONES_CHANGE': {
      const empreTelefonesCopy = [...state.empreTelefones]
      empreTelefonesCopy[action.index][action.name] = action.value
      return { ...state, empreTelefones: empreTelefonesCopy }
    }
    case 'EMPRESA_CONTA_BANCARIA_FETCHED':
      return { ...state, empreContasBancarias: action.payload }
    case 'CONTATO_FETCHED':
      return { ...state, empreTelefone: action.payload }
    default:
      return state
  }
}